import ProductPageSSR from "../../../../components/product-pageSSR";
import ProductPage from "../../../../components/product-page";
import { IS_MOBILE } from "../../../../data/js/server-constants";

// Import getStaticPaths and getStaticProps from product-main which has the full implementation
export { getStaticPaths, getStaticProps } from "../../../../components/product-main";

export default IS_MOBILE ? ProductPage : ProductPageSSR;